import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-300">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <span className="text-2xl font-heading font-bold text-primary-500">🍌</span>
              <span className="text-lg font-heading font-bold text-background-50">香蕉影视</span>
            </Link>
            <p className="text-sm leading-relaxed text-foreground-400">
              香蕉影视提供高清免费在线观看，不缓冲秒开，最新热播电影、电视剧、综艺大全，全集免费在线看，高清流畅不卡顿，追剧必备。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">影视分类</h4>
            <ul className="space-y-2">
              <li><Link to="/category/movie" className="text-sm text-foreground-400 hover:text-background-50 cursor-pointer transition-colors">电影</Link></li>
              <li><Link to="/category/tv" className="text-sm text-foreground-400 hover:text-background-50 cursor-pointer transition-colors">电视剧</Link></li>
              <li><Link to="/category/variety" className="text-sm text-foreground-400 hover:text-background-50 cursor-pointer transition-colors">综艺</Link></li>
              <li><Link to="/category/anime" className="text-sm text-foreground-400 hover:text-background-50 cursor-pointer transition-colors">动漫</Link></li>
              <li><Link to="/category/documentary" className="text-sm text-foreground-400 hover:text-background-50 cursor-pointer transition-colors">纪录片</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">热门推荐</h4>
            <ul className="space-y-2">
              <li><Link to="/article/liu-lang-di-qiu-3" className="text-sm text-foreground-400 hover:text-background-50 cursor-pointer transition-colors">流浪地球3</Link></li>
              <li><Link to="/article/kuang-biao-zhi-feng-bao-zai-qi" className="text-sm text-foreground-400 hover:text-background-50 cursor-pointer transition-colors">狂飙之风暴再起</Link></li>
              <li><Link to="/article/da-feng-da-geng-ren" className="text-sm text-foreground-400 hover:text-background-50 cursor-pointer transition-colors">大奉打更人</Link></li>
              <li><Link to="/article/cheng-feng-po-lang-di-wu-ji" className="text-sm text-foreground-400 hover:text-background-50 cursor-pointer transition-colors">乘风破浪第五季</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">关于我们</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-background-50 cursor-pointer transition-colors">品牌介绍</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-background-50 cursor-pointer transition-colors">联系我们</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">© 2025 香蕉影视 版权所有 | 高清免费在线观看平台</p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-background-50 cursor-pointer transition-colors" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-background-50 cursor-pointer transition-colors" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}